import { optionTitle_Theme, optionSearch_Theme } from './ThemeOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';

const lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));

let ThemeOption: LazyOption = createLazyOption(
    {
        key: 'theme',
        titleStringKey: optionTitle_Theme,
        searchTermsStringKey: optionSearch_Theme,
        allowedOptionKeys: ['Theme'],
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);

export default ThemeOption;
